<template>
  <div class="d-flex align-center">
    <icon-text-btn
      @onClick="onOpen"
      icon="mdi-file-table-box-outline"
      :text="$t('fahrdienst.chooseDuty')"
      :hint="$t('fahrdienst.dutySelectionHint')"
      small
      :width="50"
      :iconColor="theme.appBar.other.color"
    ></icon-text-btn>
    <v-dialog v-model="isOpen" :fullscreen="!!xs" :maxWidth="xs ? '100vw' : '800px'" :close-on-content-click="false" offset-y>
      <v-card>
        <v-btn icon @click="isOpen = false" style="position: absolute; right: 5px; top: 5px">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title>
          <custom-date-picker v-model="selectedDate" :color="$props.activeColor"></custom-date-picker>
          <v-text-field
            class="ml-5 mt-7"
            :width="200"
            :label="'Filter'"
            :placeholder="$t('fahrdienst.chooserPlaceholder')"
            v-model="filter"
            rounded
            outlined
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <div v-if="isOpen" class="pa-1 inner-container-1">
            <!-- <div class="text-h5 text-no-wrap">Kurs / Linien {{ selectedDate }}</div> -->
            <div class="scroll-container" style="overflow-x: auto; height: 70vh; font-size: 12px">
              <div class="d-flex flex-wrap">
                <div v-for="(duty, ind) in filteredDuties" :key="ind" v-ripple @click="onCellSelected(duty)">
                  <div v-if="duty" class="cell" :class="cellClass(duty)">{{ duty ? duty.title : '' }}</div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from '@/mixins/common';
import IconTextBtn from '@/components/buttons/IconTextBtn.vue';
import CustomDatePicker from '@/components/pickers/CustomDatePicker.vue';
import sortFunctions from '@/sorters/sortFunctions';
import fahrdienstUtil from '@/modules/fahrdienst/fahrdienstUtil';
import DB from '@/modules/fahrdienst/storeNonReactive';
import fahrdienstMixin from '@/modules/fahrdienst/fahrdienstMixin';
import configMixin from '@/mixins/configMixin';
import index from './index';

export default {
  name: 'DateDutySelection',
  mixins: [common, fahrdienstMixin, configMixin],
  components: {
    CustomDatePicker,
    IconTextBtn,
  },
  props: {
    color: String,
    duty: Object,
    date: Date,
  },
  data() {
    return {
      selectedDate: this.date,
      selectedDuty: this.duty,
      columnCount: 15,
      isOpen: false,
      filter: null,
    };
  },
  computed: {
    moduleConfig() {
      return this.getModuleConfig(index.moduleType, this.$route.params.instance);
    },
    fahrdienstDuties() {
      return this.$store.state.fahrdienst.fahrdienstDuties;
    },
    filteredDuties() {
      return (
        this.dutiesAtSelectedDate
          // .filter((d) => d.inst == this.instance && d.hasFiles)
          // .filter((d) => d.inst == this.instance) //TODO: wirklich richtig, diesen Filter wegzulassen?
          // bei der alten App sieht es genauso aus, ist aber im Prinzip wohl falsch, da die Instanz nicht berücksichtigt wird
          .filter((d) => !this.filter || (d && d.title.indexOf(`${this.filter}`)) > -1)
          .sort((a, b) => sortFunctions.compareValues(a.title, b.title))
      );
    },
    dutiesAtSelectedDate() {
      //console.debug('compute dutiesAtSelectedDate');
      if (this.fahrdienstTypeIds.length > 0) {
        let dutiesAtSelectedDate = fahrdienstUtil.getDutiesAtSelectedDate({
          date: this.selectedDate,
          fahrdienstDuties: this.fahrdienstDuties,
          dutyFilesTypeIdFk: this.fahrdienstTypeIds,
          files: this.instanceFiles,
          instance: Number(this.$route.params.instance),
          verkehrsPeriodenKalender: DB.verkehrsPeriodenKalender,
          additionalFahrdienstDays: DB.additionalFahrdienstDays,
          cancelledFahrdienstDays: DB.cancelledFahrdienstDays,
          filterByDate: this.moduleConfig.fahrdienstDutyListSelectedDateOnly,
        });
        return dutiesAtSelectedDate;
      }
      return [];
    },
  },
  methods: {
    onOpen() {
      console.debug('click received to open duty selection');
      this.isOpen = true;
      // setTimeout required, otherwise the dialog is not opened. Reason unclear
      setTimeout(() => {
        this.isOpen = true;
      }, 300);
    },
    onCellSelected(duty) {
      this.isOpen = false;
      this.$emit('onSelectionCompleted', { date: this.selectedDate, duty });
    },
    cellClass(duty) {
      let clz = ''; //duty.hasFiles ? 'with-file' : '';
      if (this.selectedDuty && duty && duty.id === this.selectedDuty.id) clz += ' selected';
      return clz;
    },
  },
  watch: {
    date(newValue, oldValue) {
      // console.debug("update selectedDate when property date changes. watch:date", newValue, "old value", oldValue);
      this.selectedDate = newValue;
    },
    duty(newValue, oldValue) {
      // console.debug("update selectedDate when property duty changes. watch:duty", newValue, "old value", oldValue);
      this.selectedDuty = newValue;
    },
    isOpen() {
      this.filter = null;
    },
  },
};
</script>

<style scoped>
.date,
.cell {
  white-space: nowrap;
  font-size: 1.1rem;
  text-align: center;
  padding: 10px;
  border-radius: 7px;
  margin: 2px;
  width: auto;
  min-width: 40px;
}
.theme--light .cell {
  background: #f0f0f0;
}
.theme--dark .cell {
  background: #303030;
}
.with-file {
  border-radius: 10px;
  border: 1px solid white;
}
.selected {
  color: var(--v-primary-base);
  font-weight: bolder;
}
</style>
